import React from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  TextField,
} from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "../../../../../../hooks/useTranslation";
import { useMarketplaceStore } from "../../../../../../store/useMarketplaceStore";

type CompetitionStrategyProps = {
  control: UseFormReturn["control"];
  translate: (_key: string) => string;
};

export const CompetitionStrategy: React.FC<CompetitionStrategyProps> = ({
  control,
  translate,
}) => {
  const { translateWithoutPrefix } = useTranslation();
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      mb={2}
      gap={2}
    >
      <Typography
        variant="body2"
        fontWeight="bold"
        sx={{ width: { xs: "100%", sm: "20%" }, mb: { xs: 1, sm: 0 } }}
      >
        {translate("competitionStrategy")}
      </Typography>
      <Controller
        name="competitionStrategy"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
            <FormControlLabel
              value="MATCH"
              control={<Radio />}
              label={translate("matchPrice")}
            />
            <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
              <FormControlLabel
                value="UNDERCUT"
                control={<Radio />}
                label={translate("undercutPrice")}
              />
              {value === "UNDERCUT" && (
                <Stack direction={"column"}>
                  <Typography variant="body2">
                    {translate("undercutValue")}:
                  </Typography>
                  <Controller
                    name="undercutValue"
                    control={control}
                    rules={{
                      required: translateWithoutPrefix(
                        "common.errors.required",
                      ),
                      min: {
                        value: 0,
                        message: translateWithoutPrefix("common.errors.min", {
                          min: 0,
                        }),
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        size="small"
                        type="number"
                        error={!!error}
                        helperText={error ? error.message : ""}
                        slotProps={{
                          input: {
                            startAdornment: (
                              <Box mr={1}>{selectedCountry?.currency}</Box>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                </Stack>
              )}
            </Stack>
          </RadioGroup>
        )}
      />
    </Box>
  );
};
